import { Text } from "@chakra-ui/react";

const Subtitle: React.FC<React.PropsWithChildren<Record<string, any>>> = ({ children, ...props }) => (
  <Text fontFamily="GT Walsheim" fontWeight="500" fontSize={["1.125rem"]} color="white" {...props}>
    {children}
  </Text>
);

export default Subtitle;
